<template>
  <main class="container p-4 text-sp-primary">
    <section class="container p-0 my-8 mt-0 text-sp-primary">
      <div v-if="loading" class="fade"><Loading /></div>
      <div v-else-if="error">{{ $t("error") }}</div>
      <div v-else>
        <h1 class="text-xl font-bold mb-4">
          "{{ query }}" {{ $t('searchResults') }}:
        </h1>
        <div class="category-list grid grid-cols-1 max-w-max">
          <RouterLink
            v-for="item in results"
            :key="item.id"
            :to="`/category/${item.categoryId}/section/${item.sectionId}/article/${item.id}`"
            @click="logClick(`search.${item.categoryId}/${item.sectionId}/${item.id}`, 'search.searchResults')"
            class="flex items-center gap-3 p-4 px-0 hover:text-sp-accent duration-150 ease-in-out"
          >          
            <img :src="item.promoted ? magentaIcon : yellowIcon" alt="dot icon" class="w-3 h-3" />
            <p class="leading-tight line-clamp-1">{{ item.title || "Untitled article" }}</p>
            <img src="../assets/icon-arrow.png" alt="arrow icon" class="w-3 ml-auto" />
          </RouterLink>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { getUserData } from '../modules/collectData.js'
import { useLogger } from '../composables/useLogger'
import { useHelpCenterFetch } from '../composables/useHelpCenterFetch'
import Loading from '../components/Loading.vue'
import yellowIcon from '../assets/icon-dot-yellow.png'
import magentaIcon from '../assets/icon-dot-magenta.png'

const route = useRoute()
const { logClick } = useLogger()
const { lang } = getUserData()

const query = ref(route.query.query || '')

const { data: results, loading, error, load } = useHelpCenterFetch(
  () => `helpcenter/${lang}/find/articles?title_like=${encodeURIComponent(query.value)}`,
  {
    select: (answer) => {
      if (!Array.isArray(answer)) throw new Error('expected array')
      return answer
    }
  }
)

onMounted(() => {
  if (query.value) load()
  logClick(`search.${query.value}`, 'search.searchResult')
})

watch(() => route.query.query, (newQuery) => {
  query.value = newQuery
  if (newQuery) load()
})
</script>